import { getFile, postFile } from 'api/baseApi'

export const getStampForUser = function (stampIndex, privilegizedEntityId) {
  return getFile({ url: '/api/server/media/stamp/get/' + stampIndex + '/' + privilegizedEntityId })
}
export const uploadStampForUser = function (file, name, privilegizedEntityId, stampIndex) {
  return postFile({ url: `/api/server/media/stamp/upload/` + stampIndex,
    fileStream: file,
    fileName: name,
    privilegizedEntityId: privilegizedEntityId})
}



// WEBPACK FOOTER //
// ./src/api/stampApi.js